import qs from "qs";
import { api } from "../config";

const getProductSpecs = async (id) => {
  const query = qs.stringify(
    {
      populate: {
        Specification: {
          populate: ["Specifications"],
        },
      },
    },
    {
      encodeValuesOnly: true,
    }
  );
  const res: any = await fetch(`${api}/products/${id}?${query}`);
  res.data = await res.json();
  return res;
};

export { getProductSpecs };
